
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';

    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop( { type: String } )
        public value: string;

        @Watch( 'value', { immediate: true } )
        onIndex() {
            this.Selected = this.value;
        }

        constructor() {
            super();
        }


        public selected: string | null = null;
        public get Selected(): string | null {
            return this.selected;
        }
        public set Selected( x: string | null ) {
            this.selected = x;
            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any ) {

        }
    }
